import { useMemo } from 'react';
import { ActionState, TurnState } from '@colonist/game-states';
export const useIsDiceActive = (currentState, playerColor, myColor, currentTurnPlayers)=>useMemo(()=>{
        if (currentTurnPlayers.length > 1) {
            return {
                active: false,
                helperText: undefined
            };
        }
        if (myColor !== playerColor) {
            return {
                active: false,
                helperText: undefined
            };
        }
        if (currentState.currentTurnPlayerColor !== playerColor) {
            return {
                active: false,
                helperText: {
                    key: 'strings:game.errors.notYourTurn'
                }
            };
        }
        if (currentState.turnState != TurnState.Dice) {
            return {
                active: false,
                helperText: {
                    key: 'strings:game.errors.diceAlreadyRolled'
                }
            };
        }
        if (currentState.actionState !== ActionState.None) {
            return {
                active: false,
                helperText: {
                    key: 'strings:game.errors.finishCurrentAction'
                }
            };
        }
        return {
            active: true,
            helperText: undefined
        };
    }, [
        currentState,
        playerColor,
        myColor
    ]);
export const useIsDiceVisible = (currentState, currentTurnPlayers, playerColor)=>useMemo(()=>{
        if (currentState.turnState === TurnState.InitialPlacement) {
            return false;
        }
        const isCurrentPlayerTurn = currentTurnPlayers.includes(playerColor);
        return isCurrentPlayerTurn;
    }, [
        currentState,
        currentTurnPlayers,
        playerColor
    ]);
